<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartMessagesCountry",
  data() {
    return {
      series:[],
      chartOptions: {
        chart: {
          id: 'messages-country',
          type: 'bar',
          stacked: true,
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,

            datetimeUTC: false,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          }
        },
        noData: {
          text: 'Loading...'
        }
      },

      filtersDates: {
        selected: '1M',
        options: [
          {value:'1M', text:'1M'},
          {value:'3M', text:'3M'},
          {value:'6M', text:'6M'},
          {value:'1Y', text:'1Y'},
        ]
      },

      filtersCount: {
        selected: 'ALL',
        options: [
          {value:'ALL', text:'ALL'},
          {value:'UQ', text:'UQ.'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected, typeCount: this.filtersCount.selected};
      StatsDataService.getMessagesCountry(params)
          .then(response => {
            const data = response.data;
            const series = [];
            for (let [key, value] of Object.entries(data.countries)) {
              series.push({
                name: key,
                data: value,
              })
            }
            this.$refs.messagesCountryChart.updateSeries(series);
          })
          .catch(error => {
            window.console.error("StatsDataService.getMessagesCountry failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardChartMessagesCountry">
      <h5 class="card-title">Messages Country History</h5>
      <b-form-radio-group
          v-model="filtersDates.selected"
          :options="filtersDates.options"
          button-variant="outline-secondary"
          size="sm"
          buttons
          class="mt-1 mb-2"
          @change="handleDateChange"
      ></b-form-radio-group>

    <b-form-radio-group
        v-model="filtersCount.selected"
        :options="filtersCount.options"
        button-variant="outline-secondary"
        size="sm"
        buttons
        class="ms-3 mt-1 mb-2"
        @change="handleDateChange"
    ></b-form-radio-group>

    <apexchart
        ref="messagesCountryChart"
        type="bar"
        dir="ltr"
        height="350"
        :series="series"
        :options="chartOptions"
    ></apexchart>
  </div>
</template>

<style>
#cardChartMessagesCountry .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardChartMessagesCountry .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>
